import React, { useState } from "react";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import { Alert, IconButton, Slide, Snackbar } from "@mui/material";
import PropTypes from "prop-types";
import CloseIcon from '@mui/icons-material/Close';

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

export default function CustomSnackbar({ notification, setNotification }) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    setNotification({});
  };

  const action = (
    <>
      <IconButton color="inherit" onClick={handleClose}>
        <CloseTwoToneIcon />
      </IconButton>
    </>
  );

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={action}
      TransitionComponent={SlideTransition}
    >
      <Alert
        onClose={handleClose}
        severity={notification.severity}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}

CustomSnackbar.propTypes = {
  notification: PropTypes.shape({
    severity: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
  setNotification: PropTypes.func.isRequired,
};